/**
 * Internal dependencies.
 */
import { domReady } from '../../../utils/helpers';

export type Product = {
	readonly id: number;
};

export function dispatchProductsAddedToCartEvent(
	products: ReadonlyArray< Product >
): void {
	if ( ! products.length ) {
		return;
	}

	domReady( () =>
		window.dispatchEvent(
			new CustomEvent( 'nab-wc-product-added-to-cart', {
				detail: [ ...products ],
			} )
		)
	);
}
